// 汇率查询 、 维护
export default {
  exchangerate: {
    label: {
      fromCurrencyCode: '币种 自',
      toCurrencyCode: '币种 至',
      exchangeDate: '日期',
      exchangeType: '汇率类型',
      positiveRate: '币种自->币种至',
      negativeRate: '币种至->币种自',
      startTime: '起始日期',
      endTime: '终止日期',
      searchStartTime: '日期从',
      searchEndTime: '日期至',
    },
    placeholder: {
      fromCurrencyCode: '请选择币种',
      toCurrencyCode: '请选择币种',
      startTime: '请选择起始日期',
      endTime: '请选择终止日期',
      exchangeType: '请选择汇率类型',
      positiveRate: '请输入正向汇率',
      negativeRate: '请输入逆向汇率',
    },
    message: {
      no_Data: '没有可保存的数据',
      please_complete_form_data: '请将表格数据填写完整',
      cancel_save_data: '取消不会保存当前数据',
      is_sure: '是否确定',
      cancelled: '已取消',
      repeat: '币种自与币种至重复，请重新选择',
      select: '请选择一条数据操作，或直接点击行数据编辑',
      startTime: '日期从必填',
      endTime: '日期至必填',
    },
    router: {
      exchangerateMaintain: '汇率维护',
      exchangerate: '查询汇率',
    },
  },
};
